import React from 'react';
import { useSelector } from 'react-redux';
import { Controller, Ref, useFormContext } from 'react-hook-form';
import { makeStyles, TextField } from '@material-ui/core';
import { RootState } from '@modules/index';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { NumberFormatCustom } from '@components/CurrencyTextfield/CurrncyTextField';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestInputCommonProps } from './types';

const CircuitFabricationQuantityInput = React.forwardRef<
  Ref,
  RequestInputCommonProps
>(({ error }, ref) => {
  const defaultValue = useSelector<RootState, number | null>(
    (state) => state.request?.pcb?.fabricationQuantity ?? null
  );
  const { control } = useFormContext();
  const { produceQuantityInput } = useStyles();

  return (
    <FormInputLayout label="제작수량" required={true}>
      <Controller
        data-cy="rfq-pcb-fabricationQuantity"
        name="pcb.fabricationQuantity"
        control={control}
        defaultValue={defaultValue}
        render={({ onChange }) => (
          <TextField
            defaultValue={defaultValue}
            className={produceQuantityInput}
            autoComplete="off"
            error={!!error}
            helperText={error}
            variant="outlined"
            fullWidth
            placeholder="0"
            InputProps={{
              inputComponent: NumberFormatCustom,
              onChange: (e) => {
                const value = (e.target as HTMLInputElement).value;
                onChange(+value);
              },
              endAdornment: (
                <CustomizedTypography variant="body1" color="textSecondary">
                  개
                </CustomizedTypography>
              )
            }}
          />
        )}
      />
    </FormInputLayout>
  );
});

export default CircuitFabricationQuantityInput;

const useStyles = makeStyles((theme) => ({
  produceQuantityInput: {
    '& input': {
      padding: 12,
      textAlign: 'right'
    },
    '& .MuiInputBase-root': {
      alignItems: 'center',
      borderRadius: 8
    },
    '& ::placeholder': {
      color: colorSet.gray500
    }
  }
}));
